import React from 'react';

const MemberProfile = ({ slaves }) => {
  const parseTitleParts = (title = '') => {
    const match = title.match(/^(.+?)\s*\((.+)\)$/);
    return match ? { name: match[1], email: match[2] } : { name: title, email: '' };
  };

  const { name, email } = parseTitleParts(slaves);

  return (
    <div className="member-profile">
      <div className="member-profile-avatar" />
      <div className="member-profile-content">
        <h6>{name}</h6>
        <p>{email}</p>
      </div>
    </div>
  );
};

export default MemberProfile;
